import api from 'Application/api/api';

const createEntityComment = async (signal, values) => {
	const response = await api.post('/contract-party-comments', values, {
		signal,
		timeout: 100000,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
		data: response.data,
	};
};

export default createEntityComment;
